// @flow
import { connect } from 'react-redux'
import type { Props } from './CardSelector'
import { getCarousel, hasCarouselCardAnyErrors } from '../../../redux/selectors'
import CardSelector from './CardSelector'
import type { Store } from '../../../redux/ducks'
import { add, patch, remove } from '../../../redux/ducks/carouselEdit/reducers'
import _ from 'lodash'
import type { CarouselCard } from '../../../redux/ducks/carouselEdit/reducers'

type OwnProps = {|
  storeId: string
|}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const carousel = getCarousel(state, ownProps.storeId)

  return {
    cards: carousel.cards,
    currentIndex: carousel.currentCardIndex,
    hasCardError: _.map(carousel.cards, (card: CarouselCard) => hasCarouselCardAnyErrors(card))
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  return {
    onAdd: () => {
      dispatch(add(ownProps.storeId))
    },
    onRemove: (index) => {
      dispatch(remove(ownProps.storeId, index))
    },
    onCurrentIndexChange: (index: number) => {
      dispatch(patch(ownProps.storeId, { currentCardIndex: index }))
    }
  }
}

const CardSelectorContainer = connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(CardSelector)

export default CardSelectorContainer
